export default {
  labels: {
    today: 'Vandaag',
    pickup_time: 'Afhaaltijd',
    delivery_time: 'Bezorgtijd',
  },
};
